import React from 'react';
import { theme } from '../theme';
import { useMaintenanceMode } from '../contexts/MaintenanceContext';

// <purpose>Non-dismissible top banner shown while the backend is in maintenance
// mode. Explains why write actions are paused + offers a reload (which lands the
// user on the maintenance page during a deploy window).</purpose>
export const MaintenanceBanner: React.FC = () => {
  const active = useMaintenanceMode();
  if (!active) return null;
  return (
    <div role="status" style={{
      backgroundColor: theme.colors.warning,
      color: theme.colors.white,
      padding: '10px 16px',
      fontSize: 14,
      fontFamily: theme.font.family,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      flexWrap: 'wrap',
    }}>
      <span>Eine neue Version von Smarttix wurde bereitgestellt. Bitte laden Sie die Seite neu. Aktionen sind währenddessen pausiert.</span>
      <button
        onClick={() => window.location.reload()}
        style={{
          background: theme.colors.white,
          color: theme.colors.navy,
          border: 'none',
          borderRadius: theme.borderRadius.sm,
          padding: '4px 12px',
          fontWeight: 600,
          fontFamily: theme.font.family,
          cursor: 'pointer',
          flexShrink: 0,
        }}
      >Neu laden</button>
    </div>
  );
};
